import { canAccessStaffPath, canManageStaffUsers } from './staffAccess';
import { localStorageHelper } from './localStorage';

export const getIsAdmin = () => {
  const userType = localStorageHelper.getItem('type');
  return userType === 'admin';
};

export const getAdminRole = () => {
  return localStorageHelper.getItem('role');
};

export const getIsAdministratorRole = () => {
  return getIsAdmin() && canManageStaffUsers(getAdminRole());
};

export const getCanAccessFinanceTools = () => {
  if (!getIsAdmin()) return false;
  return canAccessStaffPath(getAdminRole(), '/payroll-hub');
};

export const getCanAccessTimeTrackingReports = () => {
  if (!getIsAdmin()) return false;
  return ['Administrator', 'Agency', 'Finance', 'HR', 'Operations', 'Account Executive'].includes(getAdminRole());
};

export const getCanAccessLinkedInReport = () => {
  if (!getIsAdmin()) return false;
  return ['Administrator', 'HR'].includes(getAdminRole());
};

// AI talent summary: Administrator, HR, Finance and Account Executive (the report rows open it; the server enforces the same list).
export const AI_SUMMARY_ROLES = ['Administrator', 'HR', 'Finance', 'Account Executive'];
export const getCanAccessTalentAiSummary = () => getIsAdmin() && AI_SUMMARY_ROLES.includes(getAdminRole());

// Employee Retention report: Administrator, HR and Account Executive. Finance no longer sees it (the server enforces the same list).
export const RETENTION_ROLES = ['Administrator', 'HR', 'Account Executive'];
export const getCanAccessRetention = () => getIsAdmin() && RETENTION_ROLES.includes(getAdminRole());
